import { render, staticRenderFns } from "./Ubm.vue?vue&type=template&id=14b03d42&scoped=true&"
import script from "./Ubm.vue?vue&type=script&lang=js&"
export * from "./Ubm.vue?vue&type=script&lang=js&"
import style0 from "./Ubm.vue?vue&type=style&index=0&id=14b03d42&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b03d42",
  null
  
)

export default component.exports